<template>
  <v-dialog :model-value="statusType !== null" width="600" @close="closeDialog" persistent>
    <v-form>
      <v-card v-if="statusType">
        <v-card-title class="d-flex flex-row ma-2">
          <h4 class="text-capitalize" data-testid="yard-spot-status-dialog-title">
            {{
              t('global.yardSpotStatusDialog.headers.actionThisSpot', {
                action: t(`global.basicTerms.${statusType.toLowerCase()}`)
              })
            }}
          </h4>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" density="comfortable" @click="closeDialog"></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-column gap-6">
            <p class="typography-body-md" v-if="statusType === 'close'">
              {{ t('global.yardSpotStatusDialog.messages.thisSpotWillRemainUnavailable') }}
            </p>
            <p class="typography-body-md" v-else-if="statusType === 'open'">
              {{ t('global.yardSpotStatusDialog.messages.thisDoorWillBeSetAsOpen') }}
            </p>

            <template v-if="statusType === 'close'">
              <div>
                <strong>
                  {{ t('global.yardSpotStatusDialog.labels.reason') }}
                </strong>
                <v-autocomplete
                  color="primary"
                  v-model="reason"
                  :placeholder="t('global.yardSpotStatusDialog.placeholders.selectAReason')"
                  :items="[
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.cleaning'),
                      value: 'Cleaning'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.underMaintenance'),
                      value: 'Under Maintenance'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.blockedByEquipment'),
                      value: 'Blocked by Equipment'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.safetyInspection'),
                      value: 'Safety Inspection'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.routineInspection'),
                      value: 'Routine Inspection'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.reserved'),
                      value: 'Reserved'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.repairsNeeded'),
                      value: 'Repairs Needed'
                    },
                    {
                      title: t('global.yardSpotStatusDialog.dropDownItems.damage'),
                      value: 'Damage'
                    }
                  ]"
                  data-testid="yard-spot-status-dialog-reason-input"
                  variant="outlined"
                  density="compact"
                  autofocus
                  required
                  clearable
                  data-allow-mismatch></v-autocomplete>
              </div>
              <div>
                <strong>
                  {{ t('global.yardSpotStatusDialog.labels.additionalNotes') }}
                </strong>

                <v-textarea
                  v-model="observation"
                  color="primary"
                  data-testid="yard-spot-status-dialog-observation-input"
                  :placeholder="`${t(
                    'global.yardSpotStatusDialog.placeholders.enterAdditionalNotes'
                  )}...`"
                  variant="outlined"
                  density="compact"
                  clearable></v-textarea>
              </div>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            @click="closeDialog"
            data-testid="yard-spot-status-dialog-cancel">
            {{ t('global.buttons.nevermind') }}
          </v-btn>
          <v-btn
            class="bg-primary"
            @click="submit"
            :disabled="statusType === 'close' && !reason"
            data-testid="yard-spot-status-dialog-submit">
            {{ t('global.buttons.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardSpotStatusDialog',
  props: {
    statusType: {
      type: [String, null],
      default: null
    }
  },
  emits: ['submit', 'close'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const reason = ref('');
    const observation = ref('');

    const submit = () => {
      emit('submit', { reason: reason.value, observation: observation.value });
      closeDialog();
    };

    const closeDialog = () => {
      reason.value = '';
      observation.value = '';
      emit('close');
    };

    return {
      t,
      submit,
      closeDialog,
      reason,
      observation
    };
  }
});
</script>
